import React, { useCallback, useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { actions } from '../../context';

const AssignUserToPracticeModal = () => {
    // TODO: make this feature its own redux slice

    const dispatch = useDispatch();

    const [adminUsers, setAdminUsers] = useState([]);

    const {
        isOpen,
        practiceId,
        name,
        assignedAccountId,
        isAssignedToCurrentUser,
    } = useSelector(
        (state) => ({
            isOpen: state.toggle.isAssignUserToPracticeModalOpen,
            practiceId: state.practice.userAssigningModalPractice.id,
            name: state.practice.userAssigningModalPractice.name,
            assignedAccountId:
                state.practice.userAssigningModalPractice.assignedAccountId,
            isAssignedToCurrentUser:
                state.practice.userAssigningModalPractice
                    .isAssignedToCurrentUser,
        }),
        shallowEqual
    );

    const toggle = useCallback(
        () => dispatch(actions.toggle.toggleAssignUserToPracticeModal(!isOpen)),
        [dispatch, isOpen]
    );

    useEffect(() => {
        if (isOpen) {
            dispatch(actions.users.getAssignableUsers()).then((res) =>
                setAdminUsers(res?.data || [])
            );
        }
        return () => {
            setAdminUsers([]);
        };
    }, [dispatch, isOpen]);

    const refreshAndClose = useCallback(() => {
        const payload = {id: '', name: '', assignedAccountId: '', isAssignedToCurrentUser: false};
        dispatch(actions.practice.selectPracticeToAssignToUser(payload));
        dispatch(actions.toggle.triggerRefresh());
        dispatch(actions.toggle.triggerPracticeRefresh());
        toggle();
    }, [dispatch, toggle]);

    const unassign = useCallback(
        () =>
            dispatch(actions.practice.removeAssignedUser(practiceId)).then(refreshAndClose),
        [dispatch, refreshAndClose, practiceId]
    );

    const submit = useCallback(
        async (vals) =>
            dispatch(
                actions.practice.setAssignedUser(practiceId, vals?.accountId)
            ).then(refreshAndClose),
        [dispatch, refreshAndClose, practiceId]
    );

    return (
        <div>
            <Modal isOpen={isOpen} toggle={toggle} centered={true}>
                <Form
                    initialValues={{
                        accountId: assignedAccountId,
                    }}
                    onSubmit={submit}
                    render={({ handleSubmit, values, pristine }) => (
                        <form onSubmit={handleSubmit}>
                            <ModalHeader className="text-light">
                                Assign to {name}
                            </ModalHeader>
                            <ModalBody className="text-center">
                                <Field
                                    name="accountId"
                                    component="select"
                                    defaultValue={""}
                                    className="p-2 rounded w-75 text-center my-4">
                                    <option value="" disabled>
                                        Select User
                                    </option>
                                    <option />
                                    {adminUsers.map((u) => (
                                        <option
                                            key={u.id}
                                            value={u.id}
                                            className="text-center my-1 py-2">
                                            {u.firstName}&nbsp;{u.lastName}
                                        </option>
                                    ))}
                                </Field>
                            </ModalBody>
                            <ModalFooter className="justify-content-between">
                                <Button color="info" onClick={toggle}>
                                    Cancel
                                </Button>
                                <div>
                                    {/* TODO: user experience here could be improved */}
                                    <Button
                                        disabled={pristine}
                                        color="primary"
                                        type="submit">
                                        Assign
                                    </Button>
                                    &emsp;
                                    {isAssignedToCurrentUser && (
                                        <Button
                                            color="danger"
                                            onClick={unassign}>
                                            Unassign
                                        </Button>
                                    )}
                                </div>
                            </ModalFooter>
                        </form>
                    )}
                />
            </Modal>
        </div>
    );
};

export default React.memo(AssignUserToPracticeModal);